import React from "react";
import "./Ball.css";


type BallProps = {
  number: number,
  className: string,
  numberClassName: string
}

export default function Ball({ number, className, numberClassName }: BallProps) {

  return (
    <div className={`ball-container ${className}`}>
      <span className={`ball-number ${numberClassName}`}>{number}</span>
      <img className="ball-image" src="./assets/images/ball.png" alt="ball" />
    </div>
  )
}